import { render, staticRenderFns } from "./CustomerOrderItem.vue?vue&type=template&id=4aea43a7&lang=pug"
import script from "./CustomerOrderItem.vue?vue&type=script&lang=js"
export * from "./CustomerOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports